import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";

const PieChart = ({
  chartWidth,
  chartHeight,
  series = [],
  labels = [],
  colors = [],
  legendPosition = "bottom",
  showLegend = true,
  tooltipTitle = "",
  tooltipFormatter = () => "",
  percentageDecimals
}) => {
  const { t } = useTranslation();
  const options = {
    series,
    chart: {
      width: chartWidth,
      type: "pie"
    },
    labels,
    colors,
    legend: { show: showLegend, position: legendPosition },
    ...(percentageDecimals === undefined
      ? {}
      : {
          dataLabels: {
            formatter: (value) =>
              `${Number(value).toFixed(percentageDecimals)}%`
          }
        }),
    tooltip: {
      y: { title: tooltipTitle, formatter: tooltipFormatter }
    }
  };
  const hasNoData = series.every((val) => val === 0);

  return hasNoData ? (
    <div className="p-3 fw-bold text-center d-flex align-items-center justify-content-center h-100">
      {t("noData")}
    </div>
  ) : (
    <Chart
      type="pie"
      options={options}
      series={options.series}
      width={"100%"}
      height={chartHeight}
    />
  );
};

export default PieChart;
